import { render, staticRenderFns } from "./DevService.vue?vue&type=template&id=1e51cdbb&scoped=true&"
import script from "./DevService.vue?vue&type=script&lang=js&"
export * from "./DevService.vue?vue&type=script&lang=js&"
import style0 from "./DevService.vue?vue&type=style&index=0&id=1e51cdbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51cdbb",
  null
  
)

export default component.exports